import React from 'react'
import ChartFlexSection from '@components/chart/ChartFlexSection'
import TextChartTitle from '@components/text/TextChartTitle'
import { Flex, Rating, Table } from '@mantine/core'
import TableHeaderColumn from '@components/table/template/TableHeaderColumn'
import { IResponseOptProjectEvaluationRanking } from '@interfaces/api/IDashboard'

const ProjectEvaluationRanking = ({ title, data }: { title: string; data: IResponseOptProjectEvaluationRanking }) => {
  return (
    <ChartFlexSection className="pagebreak">
      <TextChartTitle>{title}</TextChartTitle>
      <Table pos={'relative'}>
        <thead>
          <tr>
            <TableHeaderColumn label={'อันดับ'} width={'3%'} />
            <TableHeaderColumn label={'รหัสโครงการ'} width={'5%'} />
            <TableHeaderColumn label={'ชื่อโครงการ'} width={'40%'} />
            <TableHeaderColumn label={'คุณภาพการให้บริการ'} width={'10%'} />
            <TableHeaderColumn label={'ขั้นตอนการให้บริการ'} width={'10%'} />
            <TableHeaderColumn label={'เจ้าหน้าที่ผู้ให้บริการ'} width={'10%'} />
            <TableHeaderColumn label={'สิ่งอำนวยความสะดวก'} width={'10%'} />
            <TableHeaderColumn label={'ผลการประเมินความพึงพอใจ'} width={'12%'} />
          </tr>
        </thead>
        <tbody>
          {data.map((p, index) => (
            <tr key={index}>
              <td>{index + 1}</td>
              <td>{p.project_code}</td>
              <td>{p.project_name}</td>

              <td>
                <RatingResult rate={p.project_evaluation_quality_result} />
              </td>
              <td>
                <RatingResult rate={p.project_evaluation_process_result} />
              </td>
              <td>
                <RatingResult rate={p.project_evaluation_personnel_result} />
              </td>
              <td>
                <RatingResult rate={p.project_evaluation_facility_result} />
              </td>
              <td>
                <RatingResult rate={p.project_evaluation_result} />
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    </ChartFlexSection>
  )
}

const RatingResult = ({ rate }: { rate: string | null }) => {
  if (rate) {
    return (
      <Flex gap="xs">
        {rate}
        <Rating fractions={5} value={Number(rate)} readOnly />
      </Flex>
    )
  } else {
    return <>ยังไม่ประเมิน</>
  }
}

export default ProjectEvaluationRanking
